module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "shaping-leaders.7baa36d9.jpeg" + "?" + Date.now();